import React, { useEffect, useState } from "react";
import "./QuestionType.css";
import CheckBoxType from "./CheckBoxType";
import SucessfullySubmited from "./SucessfullySubmited";
import SubmisshionByUpload from "./SubmisshionByUpload";
import axios from "../../../../axios";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

export default function AllQuestions({ handleQuestionfalse }) {
  const { state } = useLocation();
  const [studentResponse, setStudentResponse] = useState();
  const [responseAnswers, setResponseAnswers] = useState([]);
  const [isGettingData, setIsGettingData] = useState(true);
  const userId = useSelector((state) => state.user?.currentUser?.id);
  useEffect(() => {
    const getStudentResponse = async () => {
      try {
        let res = await axios.get(
          `homework/${state.homeworkId}/studentResponse/student/${userId}/get`
        );
        res && setStudentResponse(res.data.data);
        setIsGettingData(false);
        // const updatedAnswers = res.data.data.answers.map((answer) => {
        //   return { ...answer, result };
        // });
        setResponseAnswers(res?.data?.data?.answers);
      } catch (error) {
        setIsGettingData(false);
        console.log(error);
      }
    };
    getStudentResponse();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [questionNo, setQuestionNo] = useState(0);
  const [allQuestion, setAllQuestion] = useState({
    sucessful: false,
  });

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate().toString().padStart(2, "0");
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };
  const handleSucessfulyfalse = () => {
    setAllQuestion({
      ...allQuestion,
      sucessful: false,
    });
  };

  console.log(responseAnswers);

  const getClassName = (element) => {
    return element.answer
      ? element.answer.key.trim() === ""
        ? "QuestionNoNonActive"
        : "QuestionActiveNo"
      : element?.descriptive_answer?.trim() === ""
        ? "QuestionNoNonActive"
        : "QuestionActiveNo";
  };

  return (
    <>
      {studentResponse ? (
        <div className=" d-flex gap-1">
          <div>
            <img
              style={{ cursor: "pointer" }}
              onClick={() => window.history.back()}
              src="/HwImg/backArrow.png"
              alt=""
            />
            &nbsp;
          </div>
          <div className="hederContainer1">
            <div>
              <div className="d-flex justify-content-between w-100  ">
                <div>
                  <span className="quesHeading">
                    {studentResponse?.homework?.name}
                  </span>
                  <span className=" open_ststus_hw ">On Review</span>
                </div>
                <div>
                  <div>
                    <div style={{ textAlign: "right" }}>
                      <span className="subTitles">Total Marks</span> &nbsp;
                      <span className="quesHeading">
                        {studentResponse?.homework?.total_marks}
                      </span>
                    </div>
                    <div>
                      <span className="subTitles">This Question</span> &nbsp;
                      <span className="quesHeading">
                        {responseAnswers[questionNo]?.question?.correct_score}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between w-100 mt-2">
                <div className="d-flex">
                  <div>
                    <span className="subTitle2">
                      {studentResponse?.homework?.subject_id?.name}
                    </span>
                    &nbsp;
                    <span>|</span> &nbsp;
                    <span className="subTitles3">Deadline</span> &nbsp;
                    <span className="subTitle2">
                      {timeHelper(studentResponse?.homework?.deadline)}
                    </span>
                    &nbsp;
                  </div>
                  <div>
                    <span>|</span> &nbsp;
                    <span className="subTitles3">Submitted</span> &nbsp;
                    <span className="subTitle2">
                      {timeHelper(studentResponse?.submitted_on)}
                    </span>
                    &nbsp;
                  </div>
                </div>
                <div className="subTitle2">
                  Questions: {questionNo + 1}/{studentResponse?.answers?.length}
                </div>
              </div>
            </div>
            <div
              style={{
                fontSize: "18px",
                fontWeight: "500",
                margin: "15px 0px",
              }}
            >
              {console.log("studentResponse", studentResponse)}{" "}
              {studentResponse?.homework?.description}
            </div>
            <div className="mt-3 d-flex gap-2 items-center justify-between">
              <div
                className="flex gap-3 mt-3"
                style={{
                  width: "100%",
                  overflowX: "auto",
                  overflowY: "hidden",
                  flexWrap: "nowrap",
                  whiteSpace: "nowrap",
                }}
              >
                {responseAnswers?.length > 0 &&
                  responseAnswers?.map((item, index) => (
                    <div
                      key={index}
                      onClick={() => setQuestionNo(index)}
                      className={getClassName(item)}
                      style={{
                        flexShrink: 0, // important to prevent shrinking
                        minWidth: "40px",

                        borderColor: item.answer
                          ? item.answer.key.trim() === ""
                            ? "#668598"
                            : "#F77F00"
                          : item?.descriptive_answer?.trim() === ""
                            ? "#668598"
                            : "#F77F00",

                        color: item.answer
                          ? item.answer.key.trim() === ""
                            ? "#668598"
                            : "#F77F00"
                          : item?.descriptive_answer?.trim() === ""
                            ? "#668598"
                            : "#F77F00",

                        backgroundColor: item.answer
                          ? item.answer.key.trim() === ""
                            ? "transparent"
                            : "#FEF2E5"
                          : item?.descriptive_answer?.trim() === ""
                            ? "transparent"
                            : "#FEF2E5",
                      }}
                    >
                      Q{index + 1}
                    </div>
                  ))}
              </div>
              <div className="d-flex gap-2 " style={{ marginRight: "0px" }}>
                {questionNo >= 1 && (
                  <button
                    className="PreviousBtnQue"
                    onClick={(e) => setQuestionNo(questionNo - 1)}
                  >
                    Previous
                  </button>
                )}

                {responseAnswers.length > questionNo + 1 && (
                  <button
                    className="nextBtnQue"
                    onClick={(e) => setQuestionNo(questionNo + 1)}
                  >
                    Next
                  </button>
                )}
              </div>
            </div>

            <div className="mt-4 allquestionTypesContainer">
              {!responseAnswers[questionNo]?.question?.type
                ?.is_manually_graded ? (
                <CheckBoxType
                  questionNo={questionNo + 1}
                  response={responseAnswers[questionNo]}
                />
              ) : (
                <SubmisshionByUpload
                  questionNo={questionNo + 1}
                  response={responseAnswers[questionNo]}
                />
              )}
            </div>
          </div>

          {allQuestion.sucessful && (
            <SucessfullySubmited
              handleSucessfulyfalse={handleSucessfulyfalse}
            />
          )}
        </div>
      ) : isGettingData ? (
        <div className="ContainerPendingSubDetail d-flex p-4 gap-1">
          <img
            className="ongoing_internal_loader"
            src="/gif/LoaderDot.gif"
            alt=""
          />
        </div>
      ) : (
        <div className="d-flex justify-content-center h-20 align-items-center w-100">
          <span
            className="px-2 py-2 d-flex align-items-center gap-2"
            style={{ fontSize: "1.2rem", fontWeight: 500 }}
          >
            ✏️ Homework Not Found
          </span>
        </div>
      )}
    </>
  );
}
